var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.processing)?_c('a',{class:_vm.buttonClass,on:{"click":function($event){$event.preventDefault();_vm.call()}}},[_c('i',{class:_vm.iconClass}),_vm._v(_vm._s(_vm.computedLabelOn)+"\n    ")]):_c('span',{class:_vm.buttonClass},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(_vm._s(_vm.computedLabelProcessing)+"\n    ")])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b970721","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/src/mixins/ClickCall.vue
// module id = 2Xoe
// module chunks = 0 1